export enum SignInMode {
   OAUTH = 'OAUTH'
}
